<template>
  <div class="cr1224-status-bar" type="flex">
    <el-row type="flex" class="overall-status" justify="end">
      <el-col tag="span" :span="4">
        {{ $t('报警状态') }}：
        <span :class="alarmStatus | alarmClass">{{ alarmStatus | alarmText }}</span>
      </el-col>
      <el-col tag="span" :span="runstate == 3 ? 6 : 4">
        {{ $t('运行状态') }}：
        <span :class="runstate | runClass">{{ runstate | runStateText }}</span>
        <span v-if="runstate == 3" :class="runstate | runClass">，{{ $t(runStateTips) }}</span>
      </el-col>
      <el-col tag="span" :span="6" v-if="alarmStatus == 2">
        {{ $t('报警内容') }}：
        <span class="danger-color">{{ alarmMsg }}</span>
      </el-col>

      <el-col tag="span" :span="4">
        <el-button @click="setTimeHandle">{{ $t('时间同步') }}</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { tools } from '../utils';
import { setTimeServer } from '@/api/devices';
import ctt from '@/utils/const';

export default {
  props: {
    alarmStatus: {
      type: Number,
      default: 0
    },
    runstate: {
      type: Number,
      default: 0
    },
    alarmMsg: {
      type: String,
      default: ''
    },
    runStateTips: {
      type: String,
      default: ''
    },
    deviseSn: {
      type: String,
      default: ''
    }
  },

  data() {
    return {};
  },
  filters: tools,
  methods: {
    setTimeHandle() {
      let obj = {
        sn: this.deviseSn,
        deviceType: ctt.CR1224,
        currTime: new Date().getTime()
      };
      setTimeServer(obj).then(res => {
        if (res.code == 200) {
          this.$message.success('同步成功');
        }
      });
      //   console.log('obj: ', obj);
    }
  }
};
</script>

<style lang="scss">
.cr1224-status-bar {
  .overall-status {
    font-weight: bold;
  }
  .el-col {
    font-size: 18px;
    padding-left: 20px;
    text-align: center;
  }
}
</style>
